import { useNavigate } from "react-router-dom";
import { sendMessage } from "../../shared/api";

import s from "./form.module.scss";

export const Form = ({ t }) => {
  const navigate = useNavigate();

  const { labels, options, messageLabels } = t.form;

  const handleSumbit = async (ev) => {
    ev.preventDefault();
    const {
      name,
      email,
      phone,
      social_media,
      citizenship,
      family,
      animals,
      date_move_in,
      city,
      rooms_number,
      budget,
      meters,
      parking,
      work_info,
      wishes,
      heardAboutUs,
      type,
    } = ev.target.elements;

    const formattedDate = date_move_in.value.split("-").reverse().join(".");

    const formData = `
${t.form.intro}:%0A%0A
${messageLabels.type}: ${type.value}%0A
${messageLabels.name}: ${name.value}%0A
${messageLabels.email}: ${email.value}%0A
${messageLabels.phone}: ${phone.value}%0A
${messageLabels.socialMedia}: ${social_media.value}%0A
${messageLabels.citizenship}: ${citizenship.value}%0A
${messageLabels.family}: ${family.value}%0A
${messageLabels.animals}: ${animals.value}%0A
${messageLabels.dateMoveIn}: ${formattedDate}%0A
${messageLabels.city}: ${city.value}%0A
${messageLabels.roomsNumber}: ${rooms_number.value}%0A
${messageLabels.budget}: ${budget.value}%0A
${messageLabels.meters}: ${meters.value}%0A
${messageLabels.parking}: ${parking.value}%0A
${messageLabels.workInfo}: ${work_info.value}%0A
${messageLabels.wishes}: ${wishes.value}%0A
${messageLabels.heardAboutUs}: ${heardAboutUs.value}%0A`;

    try {
      await sendMessage(formData);
      navigate("form_submitted");
    } catch (error) {
      alert(t.form.alertError);
      console.error(error);
    }
  };

  return (
    <form className={s.form} id="userForm" onSubmit={handleSumbit}>
      <p className={s.formLabel}>{labels.type}</p>
      <div className={s.formRadioWrapper}>
        <div className={s.formRadioInputLabelWrapper}>
          <input
            className={s.formRadioInput}
            type="radio"
            id="buy"
            name="type"
            value={options.type.buy}
            required
          />
          <label className={`${s.formRadioLabel} ${s.formLabel}`} htmlFor="buy">
            {options.type.buy}
          </label>
        </div>
        <div className={s.formRadioInputLabelWrapper}>
          <input
            className={s.formRadioInput}
            type="radio"
            id="rent"
            name="type"
            value={options.type.rent}
            required
          />
          <label
            className={`${s.formRadioLabel} ${s.formLabel}`}
            htmlFor="rent"
          >
            {options.type.rent}
          </label>
        </div>
      </div>
      <label className={s.formLabel} htmlFor="name">
        {labels.name}
      </label>
      <input
        name="name"
        id="surname"
        className={s.formInput}
        type="text"
        required
      />
      <label className={s.formLabel} htmlFor="email">
        {labels.email}
      </label>
      <input
        name="email"
        id="email"
        className={s.formInput}
        type="email"
        required
      />
      <label className={s.formLabel} htmlFor="phone">
        {labels.phone}
      </label>
      <input
        name="phone"
        id="phone"
        className={s.formInput}
        type="tel"
        required
      />
      <label className={s.formLabel} htmlFor="social_media">
        {labels.socialMedia}
      </label>
      <input
        name="social_media"
        id="social_media"
        className={s.formInput}
        type="text"
        required
      />
      <label className={s.formLabel} htmlFor="citizenship">
        {labels.citizenship}
      </label>
      <input
        name="citizenship"
        id="citizenship"
        className={s.formInput}
        type="text"
        required
      />
      <label className={s.formLabel} htmlFor="family">
        {labels.family}
      </label>
      <input
        name="family"
        id="family"
        className={s.formInput}
        type="text"
        required
      />
      <label className={s.formLabel} htmlFor="animals">
        {labels.animals}
      </label>
      <input
        name="animals"
        id="animals"
        className={s.formInput}
        type="text"
        required
      />
      <label className={s.formLabel} htmlFor="date_move_in">
        {labels.dateMoveIn}
      </label>
      <input
        name="date_move_in"
        id="date_move_in"
        className={s.formInput}
        type="date"
        required
      />
      <p className={s.formLabel}>{labels.city}</p>
      <div className={s.formRadioWrapper}>
        <div className={s.formRadioInputLabelWrapper}>
          <input
            className={s.formRadioInput}
            type="radio"
            id="wroclaw"
            name="city"
            value={options.city.wroclaw}
            required
          />
          <label
            className={`${s.formRadioLabel} ${s.formLabel}`}
            htmlFor="wroclaw"
          >
            {options.city.wroclaw}
          </label>
        </div>
        <div className={s.formRadioInputLabelWrapper}>
          <input
            className={s.formRadioInput}
            type="radio"
            id="warsaw"
            name="city"
            value={options.city.warsaw}
            required
          />
          <label
            className={`${s.formRadioLabel} ${s.formLabel}`}
            htmlFor="warsaw"
          >
            {options.city.warsaw}
          </label>
        </div>
      </div>
      <p className={s.formLabel}>{labels.roomsNumber}</p>
      <div className={s.formRadioWrapper}>
        <div className={s.formRadioInputLabelWrapper}>
          <input
            className={s.formRadioInput}
            type="radio"
            id="studio"
            name="rooms_number"
            value={options.roomsNumber.studio}
            required
          />
          <label
            className={`${s.formRadioLabel} ${s.formLabel}`}
            htmlFor="studio"
          >
            {options.roomsNumber.studio}
          </label>
        </div>
        <div className={s.formRadioInputLabelWrapper}>
          <input
            className={s.formRadioInput}
            type="radio"
            id="twoRoom"
            name="rooms_number"
            value={options.roomsNumber.twoRoom}
            required
          />
          <label
            className={`${s.formRadioLabel} ${s.formLabel}`}
            htmlFor="twoRoom"
          >
            {options.roomsNumber.twoRoom}
          </label>
        </div>
        <div className={s.formRadioInputLabelWrapper}>
          <input
            className={s.formRadioInput}
            type="radio"
            id="threeRoom"
            name="rooms_number"
            value={options.roomsNumber.threeRoom}
            required
          />
          <label
            className={`${s.formRadioLabel} ${s.formLabel}`}
            htmlFor="threeRoom"
          >
            {options.roomsNumber.threeRoom}
          </label>
        </div>
        <div className={s.formRadioInputLabelWrapper}>
          <input
            className={s.formRadioInput}
            type="radio"
            id="house"
            name="rooms_number"
            value={options.roomsNumber.house}
            required
          />
          <label
            className={`${s.formRadioLabel} ${s.formLabel}`}
            htmlFor="house"
          >
            {options.roomsNumber.house}
          </label>
        </div>
        <div className={s.formRadioInputLabelWrapper}>
          <input
            className={s.formRadioInput}
            type="radio"
            id="room"
            name="rooms_number"
            value={options.roomsNumber.room}
            required
          />
          <label
            className={`${s.formRadioLabel} ${s.formLabel}`}
            htmlFor="room"
          >
            {options.roomsNumber.room}
          </label>
        </div>
      </div>
      <label className={s.formLabel} htmlFor="budget">
        {labels.budget}
      </label>
      <input
        name="budget"
        id="budget"
        className={s.formInput}
        type="text"
        required
      />
      <label className={s.formLabel} htmlFor="apartment_area">
        {labels.meters}
      </label>
      <input
        name="meters"
        id="apartment_area"
        className={s.formInput}
        type="text"
        required
      />
      <p className={s.formLabel}>{labels.parking}</p>
      <div className={s.formRadioWrapper}>
        <div className={s.formRadioInputLabelWrapper}>
          <input
            className={s.formRadioInput}
            type="radio"
            id="Yes"
            name="parking"
            value={options.parking.yes}
            required
          />
          <label className={`${s.formRadioLabel} ${s.formLabel}`} htmlFor="Yes">
            {options.parking.yes}
          </label>
        </div>
        <div className={s.formRadioInputLabelWrapper}>
          <input
            className={s.formRadioInput}
            type="radio"
            id="No"
            name="parking"
            value={options.parking.no}
            required
          />
          <label className={`${s.formRadioLabel} ${s.formLabel}`} htmlFor="No">
            {options.parking.no}
          </label>
        </div>
      </div>
      <label className={s.formLabel} htmlFor="work_info">
        {labels.workInfo}
      </label>
      <input
        name="work_info"
        id="work_info"
        className={s.formInput}
        type="text"
        required
      />
      <label className={s.formLabel} htmlFor="wishes">
        {labels.wishes}
      </label>
      <input
        name="wishes"
        id="wishes"
        className={s.formInput}
        type="text"
        required
      />
      <label className={s.formLabel} htmlFor="heardAboutUs">
        {labels.heardAboutUs}
      </label>
      <input
        name="heardAboutUs"
        id="heardAboutUs"
        className={s.formInput}
        type="text"
        required
      />
      <label className={s.formConsentLabel} htmlFor="personal_data_consent">
        <input
          className={s.formConsentCheckbox}
          type="checkbox"
          id="personal_data_consent"
          name="personal_data_consent"
          required
        />
        <span className={s.formConsentText}>
          {t.form.consent}
        </span>
      </label>
    </form>
  );
};
